import React from "react";
import { HeaderToolbar } from "./HeaderToolbar";
import { SideWidgetsContainer } from "./SideWidgetsContainer";
import { MainPanel } from "./MainPanel";
import { Modal } from "../ui/Modal";
import { NotificationsPanel } from "../alerts/NotificationsPanel";
import { ScreenContainer } from "../ui/ScreenContainer";
import WalkthroughPanel from "../walkthrough/WalkthroughPanel";
import StartTourButton from "../ui/StartTourButton";

export const OperationPage: React.FC = () => {
  return (
    <ScreenContainer
      className="h-screen w-screen"
      targetWidth={1815}
      targetHeight={1024}
    >
      <div className="bg-crane-primary text-crane-white w-full h-full">
        <HeaderToolbar userInitials="MC" />

        <main className="p-6 relative overflow-hidden">
          <SideWidgetsContainer mainPanelSlot={<MainPanel />} />
          <NotificationsPanel />
          <WalkthroughPanel />
          <StartTourButton />
        </main>

        <Modal />
      </div>
    </ScreenContainer>
  );
};
